var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtondelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6667 11.3332C14.6667 10.4127 15.4129 9.6665 16.3333 9.6665H19.6667C20.5871 9.6665 21.3333 10.4127 21.3333 11.3332V12.9998H23.8247C23.8299 12.9998 23.835 12.9998 23.8402 12.9998H24.6667C25.1269 12.9998 25.5 13.3729 25.5 13.8332C25.5 14.2934 25.1269 14.6665 24.6667 14.6665H24.6093L23.9418 24.0113C23.8483 25.3196 22.7597 26.3332 21.4481 26.3332H14.5519C13.2403 26.3332 12.1517 25.3196 12.0582 24.0113L11.3907 14.6665H11.3333C10.8731 14.6665 10.5 14.2934 10.5 13.8332C10.5 13.3729 10.8731 12.9998 11.3333 12.9998H12.1598C12.165 12.9998 12.1701 12.9998 12.1753 12.9998H14.6667V11.3332ZM13.0616 14.6665L13.7206 23.8925C13.7518 24.3286 14.1147 24.6665 14.5519 24.6665H21.4481C21.8853 24.6665 22.2482 24.3286 22.2794 23.8925L22.9384 14.6665H13.0616ZM19.6667 12.9998H16.3333V11.3332H19.6667V12.9998ZM16.3333 16.3332C16.7936 16.3332 17.1667 16.7063 17.1667 17.1665V22.1665C17.1667 22.6267 16.7936 22.9998 16.3333 22.9998C15.8731 22.9998 15.5 22.6267 15.5 22.1665V17.1665C15.5 16.7063 15.8731 16.3332 16.3333 16.3332ZM19.6667 16.3332C20.1269 16.3332 20.5 16.7063 20.5 17.1665V22.1665C20.5 22.6267 20.1269 22.9998 19.6667 22.9998C19.2064 22.9998 18.8333 22.6267 18.8333 22.1665V17.1665C18.8333 16.7063 19.2064 16.3332 19.6667 16.3332Z",
    fill: "#E03E2D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 3.5,
    stroke: "#E03E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtondelete);
export default __webpack_public_path__ + "static/media/Buttondelete.f1ac1161fa1094defc38d0579f045e53.svg";
export { ForwardRef as ReactComponent };